/**
 * Created by Gaplo917 on 3/9/2017.
 */
import * as PIXI from 'pixi.js'
import TWEEN from "@tweenjs/tween.js"
import Scene from "../objects/Scene"
import R from "../config/R"
import FullScreenBg from "../objects/FullScreenBg"
import * as Events from "../Events"
import * as _ from "lodash"
import SoundManager from "../SoundManager"
import Button from "../objects/Button"
import {BannerText} from "../characters/common/BannerText";
import {Timer} from "../characters/common/Timer";
import QuestionController from "../controllers/QuestionController";
import QuestionBox from "../characters/common/QuestionBox";
import LifeBarController from "../controllers/LifeBarController";
import Heart from "../characters/common/Heart";
import Image from "../objects/Image";
import {Man} from "../characters/common/Man";
import * as Rx from 'rxjs'
import {SpeechBubble} from "../characters/common/SpeechBubble";
import {CheckPointArrow} from "../characters/common/CheckPointArrow"
import InfoScene from "./InfoScene"
import {Door} from "../characters/common/Door"
import {Owl} from "../characters/level3/Owl"
import {Tortoise} from "../characters/level3/Tortoise"
import {TreeStick} from "../characters/level3/TreeStick"
import {BigStone} from "../characters/level3/BigStone"
import {Spider} from "../characters/level3/Spider"
import {WoodBox} from "../characters/level3/WoodBox"
import {Crocodile} from "../characters/level3/Crocodile"
import {Rock} from "../characters/level3/Rock"
import {TimeBar} from "../objects/TimeBar";

const GameState = {
  ANSWER_CORRECT:                     "ANSWER_1_CORRECT",
  ANSWER_WRONG:                       "ANSWER_1_WRONG",
  PASS_GAME:                          "PASS_GAME",
  LOSE_GAME:                          "LOSE_GAME",
  CHECKPOINT_1:                       1,
  CHECKPOINT_2:                       2,
  CHECKPOINT_3:                       3,
  CHECKPOINT_4:                       4,
}

const END_GAME = 3

export class LevelScene3 extends Scene {
  constructor(resources, settings) {
    super()
    SoundManager.instance.stopBackground()

    this.resources = resources
    this.settings = settings
    this.passedLevel = settings.passedLevel + 1

    const questionController = new QuestionController(R.settings.level3Settings)
    questionController.prepareQuestions()

    const bg = new FullScreenBg(resources[R.images.level3_bg.name].texture)
    const river = (() => {
      const img = new Image(1024, 1300, resources[R.images.river.name].texture)
      img.alpha = 0.7
      return img
    })()
    const timeBar = new TimeBar(100, 55, resources)
    const restartBtn = new Button(1940,1450, resources[R.images.returnBtn.name].texture)
    const timer = new Timer(1790, 100, resources)
    const questionBox = new QuestionBox(600, 200, questionController.questions, resources, R.settings.level3Settings.level)
    const door = new Door(2150, 920, resources)

    // const startptArrow = new CheckPointArrow(500, 620, 0.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow1 = new CheckPointArrow(500, 620, 0.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow2 = new CheckPointArrow(1270, 160, -2.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow3 = new CheckPointArrow(1550, 750, -2.5, resources[R.images.checkPointArrow.name].texture)
    const chkptArrow4 = new CheckPointArrow(100, 1380, 1.5, resources[R.images.checkPointArrow.name].texture)

    //animation
    const bubble = new SpeechBubble(600, 900, resources)
    const man = new Man(300, 1190, resources)
    const owl = new Owl(100, 350, resources)
    const tortoise1 = new Tortoise(2048 + 200, 1300, resources)
    const tortoise2 = new Tortoise(2048 + 400, 1280, resources)
    const tortoise3 = new Tortoise(2048 + 600, 1250, resources)
    const treeStick = new TreeStick(1500, 385, resources)
    const bigStone = new BigStone(1742, 160, resources)
    const spider = new Spider(120, 570, resources)
    const woodBox = new WoodBox(1830, 1000, resources)
    const crocodile = new Crocodile(700, 1450, resources)
    const rock = new Rock(2200, 1250, resources)

    this.addChild(bg)
    this.addChild(bubble)
    this.addChild(owl)
    this.addChild(woodBox)
    this.addChild(tortoise1)
    this.addChild(tortoise2)
    this.addChild(tortoise3)
    this.addChild(treeStick)
    this.addChild(door)
    this.addChild(questionBox)
    // this.addChild(startptArrow)
    this.addChild(chkptArrow1)
    this.addChild(chkptArrow2)
    this.addChild(chkptArrow3)
    this.addChild(chkptArrow4)
    this.addChild(crocodile)
    this.addChild(bigStone)
    this.addChild(river)
    this.addChild(spider)
    this.addChild(man)
    this.addChild(rock)
    this.addChild(restartBtn)
    this.addChild(timeBar)
    this.addChild(timer)


    this.currentCheckPoint = 0
    this.questionBox = questionBox
    this.questionController = questionController
    this.score = timer
    this.timeBar = timeBar
    this.man = man
    // this.startptArrow = startptArrow
    this.chkptArrow1 = chkptArrow1
    this.chkptArrow2 = chkptArrow2
    this.chkptArrow3 = chkptArrow3
    this.chkptArrow4 = chkptArrow4
    this.door = door
    this.owl = owl
    this.tortoise1 = tortoise1
    this.tortoise2 = tortoise2
    this.tortoise3 = tortoise3
    this.treeStick = treeStick
    this.bigStone = bigStone
    this.spider = spider
    this.woodBox = woodBox
    this.crocodile = crocodile
    this.rock = rock


    this.scheduleStartGame = setTimeout(() => {
      SoundManager.instance.playBackground(R.sounds.bg_6bg1_bg3)

      const t0 = timer.flashing()
      const t1 = bubble.appear()
      const t2 = bubble.disappear()
      const t3 = new TWEEN.Tween()
        .onComplete(() => {
          timeBar.start(PIXI.ticker.shared, R.settings.common.timer)
          this.questionBox.enableQuestionBox()
        })
      t0.chain(t1)
      t1.chain(t2)
      t2.chain(t3)
      t0.start()
    }, 1500)

    restartBtn.displayGroup = new PIXI.DisplayGroup(9, true)
    restartBtn.addOnClickListener(() => {
      this.backToSelection()
    })

    this.setUpEventHandling()

    // for dev
    // this.changeGameStateTo(4, {})
  }

  playStartGameVO(cb){
    return SoundManager.instance.playEffect(R.sounds.pth_6b_g1_vo05, cb)
  }

  setUpEventHandling(){
    Events.hub.getEventStream(Events.ANSWERED)
      .throttleTime(500 /* ms */)
      .filter(() => this.timeBar.value > 0.2)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(({ choice, answer }) => {

        const isCorrect = this.questionController.isCorrect(choice, answer)

        if (isCorrect) {
          this.changeGameStateTo(GameState.ANSWER_CORRECT, {})
        } else {
          this.changeGameStateTo(GameState.ANSWER_WRONG, {})
        }
      })

      Events.hub.getEventStream(Events.NO_LIFE_LEFT)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timeBar.value > 0.2)
      .subscribe(() => {
        this.man.isLoseAndHoldPos = true
        this.changeGameStateTo(GameState.LOSE_GAME, {})
      })

    Events.hub.getEventStream(Events.TIMES_UP)
      .take(1)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.man.isLoseAndHoldPos = true
        this.man.unhappy()
        this.changeGameStateTo(GameState.LOSE_GAME, {})
      })

    Events.hub.getEventStream(Events.MEET_CHECKPOINT)
      .do(() => {
        this.currentCheckPoint = this.currentCheckPoint + 1
        if(this.currentCheckPoint === GameState.CHECKPOINT_4){
          this.timeBar.stop()
        }
      })
      .delay(1500)
      .filter(() => this.timeBar.value > 0.2)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.questionBox.disableQuestionBox()
        this.changeGameStateTo(this.currentCheckPoint, {})
      })

    Events.hub.getEventStream(Events.ENABLE_QUESTION_BOX)
      .delay(1500)
      .filter(() => this.timeBar.value >= 1)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.questionBox.enableQuestionBox()
      })

    Events.hub.getEventStream(Events.STOP_TIMER)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.timeBar.stop()
      })

    Events.hub.getEventStream(Events.DECREASE_LIFE)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .filter(() => this.timeBar.value > 0.2)
      .subscribe(() => {
        this.timeBar.deductTime(10)
        Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
      })

    Events.hub.getEventStream(Events.END_GAME)
      .take(1)
      .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
      .subscribe(() => {
        this.changeGameStateTo(GameState.PASS_GAME, {})
      })
  }

  changeGameStateTo(state, data){
    if (state === GameState.ANSWER_CORRECT){
      SoundManager.instance.playEffect(R.sounds.correct)
      console.log('the answer is correct')
      this.score.addScore()
      this.questionBox.disableQuestionBox({ isVisible: true})

      if (!this.questionController.isMeetCheckPoint()){
        if(!this.questionBox.isLastQuestion()){
          Rx.Observable.of(0)
            .delay(R.delay.afterAnswerEachQuestion)
            .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
            .subscribe(() => {
              Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              this.questionBox.nextQuestion()
            })
        }
      }

    }
    else if (state === GameState.ANSWER_WRONG) {
      SoundManager.instance.playEffect(R.sounds.wrong)
      console.log('the answer is wrong')
      this.questionBox.disableQuestionBox()
      this.rock.dropping()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          SoundManager.instance.playEffect(R.sounds.wrong_ans_eff_3)
          this.man.getRollByStone()
        })
    }
    else if (state === GameState.CHECKPOINT_1) {

      this.chkptArrow1.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.owl.addOnClickListener(() => {
            //remove arrow
            this.chkptArrow1.remove()

            const r1 = this.owl.wakeUp()

            r1
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })
          })
        })
    }
    else if (state === GameState.CHECKPOINT_2) {

      this.chkptArrow2.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.treeStick.addOnClickListener(() => {
            //remove arrow
            this.chkptArrow2.remove()

            const r0 = this.owl.flyingToWoodStick().do(() => this.removeChild(this.treeStick))
            const r12 = Rx.Observable.combineLatest(this.owl.flyWithStick(this.treeStick),this.bigStone.rolling())
            const r3 = this.crocodile.stunning()
            const r4 = this.bigStone.sinking()
            const r5 = this.crocodile.sinking()

            r0.flatMap(() => {return r12})
              .flatMap(() => {return r3})
              .delay(100)
              .flatMap(() => {return r4})
              .flatMap(() => {return r5})
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
            })
          })
        })
    }
    else if (state === GameState.CHECKPOINT_3) {

      this.chkptArrow3.flashing()

      Rx.Observable.of(0)
        .delay(1000)
        .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
        .subscribe(() => {
          this.woodBox.addOnClickListener(() => {
            //remove arrow
            this.chkptArrow3.remove()

            Rx.Observable.of(0)
              .delay(5200)
              .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
              .subscribe(() => {
                SoundManager.instance.playEffect(R.sounds.level3_turtle)
              })

            const r0 = this.tortoise1.walking(5000, 400).flatMap(() => this.tortoise1.retracting())
            const r1 = this.tortoise2.walking(6666, 0).flatMap(() => this.tortoise2.retracting())
            const r2 = this.tortoise3.walking(8333, -400).flatMap(() => this.tortoise3.retracting())
            const combine = Rx.Observable.combineLatest(r0,r1,r2)

            combine
              .subscribe(() => {
                Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
              })

          })
        })
    }
    else if (state === GameState.CHECKPOINT_4) {

      this.chkptArrow4.flashing()

      this.spider.addOnClickListener(() => {
        this.chkptArrow4.remove()

        const r2 = this.spider.putTheKeyInNet()
        const r3 = this.door.appearing()
        const r4 = this.spider.openDoor()
        const r5 = this.man.walking()

        r2
          .flatMap(() => {return r3})
          .flatMap(() => {return r4})
          .delay(500)
          .do(() => {
            setTimeout(() => SoundManager.instance.playEffect(R.sounds.sfx_clap, 1000))
          })
          .flatMap(() => {return r5})
          .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
          .subscribe(() => {
            Events.hub.publishEvent(Events.END_GAME, {})
          })
      })
    }
    else if (state === GameState.PASS_GAME) {
      this.timeBar.stop()
      this.questionBox.disableQuestionBox()
      this.endGame()
    }
    else if (state === GameState.LOSE_GAME) {
      this.timeBar.stop()
      this.questionBox.disableQuestionBox()
      SoundManager.instance.playEffect(R.sounds.fail_level1, () => {
        this.popUpInfoScene(this.resources[R.images.fail_03.name].texture)
        SoundManager.instance.playEffect(R.sounds.game_feedback_bad, () => {
          Rx.Observable.of(0)
            .delay(4000)
            .takeUntil(Events.hub.getEventStream(Events.NEXT_SCENE))
            .subscribe(() => {
              this.playAgain()
            })
        })
      })
    }
  }

  stop(){
    this.timeBar.stop()
  }

  destroy(){
    TWEEN.removeAll()
    this.timeBar.stop()
    clearTimeout(this.scheduleStartGame)
    super.destroy({children: true})
  }

  backToSelection(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.SELECTION })
  }

  playAgain(){
    this.destroy()
    this.passedLevel = this.passedLevel - 1
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.LEVEL_3, data : { passedLevel : this.passedLevel }})
  }

  popUpInfoScene(texture){
    this.infoScene = new InfoScene(this.resources, texture)
    this.addChild(this.infoScene)
  }

  nextScene(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.END_GAME })
  }

  endGame(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.END_GAME })
  }
}



// WEBPACK FOOTER //
// ./src/game/scenes/LevelScene3.js